import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enCommon from "../locales/en/common.json";
import deCommon from "../locales/de/common.json";

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: "en",
		supportedLngs: ["en", "de"],
		resources: {
			en: { common: enCommon },
			de: { common: deCommon },
		},
		ns: ["common"],
		defaultNS: "common",
		detection: {
			order: ["querystring", "localStorage", "navigator"],
			lookupQuerystring: "lng",
			caches: ["localStorage"],
		},
		interpolation: { escapeValue: false },
	});

export default i18n;
